import { render, staticRenderFns } from "./fileInfo.vue?vue&type=template&id=7c5358e6&scoped=true&"
import script from "./fileInfo.vue?vue&type=script&lang=js&"
export * from "./fileInfo.vue?vue&type=script&lang=js&"
import style0 from "./fileInfo.vue?vue&type=style&index=0&id=7c5358e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5358e6",
  null
  
)

export default component.exports